import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UcWordPipe } from './uc-words/uc-words.pipe';
import { PhoneNumberPipe } from './phone-number/phone-number.pipe';
import { AmountDollarPipe } from './amount-dollar/amount-dollar.pipe';
import { NameCasePipe } from './name-case.pipe';

const _importExports = [
  UcWordPipe,
  NameCasePipe,
  PhoneNumberPipe,
  AmountDollarPipe,
];
@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ..._importExports
  ],
  exports: [
    ..._importExports
  ]
})
export class PipesModule { }



// WEBPACK FOOTER //
// ./src/app/shared/pipes/pipes.module.ts